import React from "react";
const contentParserOptions = {
  replace: domNode => {
    if (
      domNode?.attribs?.["data-blocktype"] ===
      "custom-block"
    ) {
      return <></>;
    }

    if (
      domNode &&
      domNode.name === "a" &&
      domNode.attribs &&
      domNode.attribs.href
    ) {
      if (domNode.attribs.href[0] === "/") {
        domNode.attribs.href = process.env
          .GATSBY_PATH_PREFIX
          ? "/" +
            process.env.GATSBY_PATH_PREFIX +
            domNode.attribs.href
          : domNode.attribs.href;
      }
    }
  },
};

export default contentParserOptions;
